module.exports = __webpack_public_path__ + "components/country-flag/static/gr-e4f09bb89d9a4231c9a1661ac0b57293.svg";